export enum UserRoles {
  SyteAdmin = 100,
  ClientAdmin = 900,
}
